import DefaultLayerGroup from "./DefaultLayerGroup";

class BiodiversityLayerGroup extends DefaultLayerGroup {
  constructor(map = null, layer_group_data) {
    super(map, layer_group_data);

    this.id = this.id.replace("default-", "");
    this.id = this.id.replace(
      layer_group_data.uuid,
      `biodiversity-${layer_group_data.uuid}`
    );
  }
}

export default BiodiversityLayerGroup;
